// extracted by mini-css-extract-plugin
export default {"icon":"PungoMenu_icon__MyV1i","menu":"PungoMenu_menu__GrQpr"};